
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { Attachment } from '@/types';
import AttachmentType from '@/components/AttachmentType.vue';
import AttachmentDate from '@/components/AttachmentDate.vue';
import AttachmentSize from '@/components/AttachmentSize.vue';

@Component({
  components: {
    AttachmentType,
    AttachmentDate,
    AttachmentSize,
  },
})
export default class AttachmentDetails extends Vue {
  @Prop(Object) readonly attachment!: Attachment | null
}
